/**
 * 采伐证相关接口
 */
import request from '../utils/axios'

/**
 * 获取当前用户采伐证列表
 * @returns
 */
export function getMyCutLicense() {
  return request({
    url: "/CutLicense/GetMyList",
    method: "GET"
  })
}
/**
 * 获取所有数据列表
 * @param {*} data
 * {
 *  "pageNumber": 0,
 *  "pageSize": 0,
 *  "keyword": "string",
 *  "orderbyType": 0,
 *  "isOrder": true
 * }
 * @returns
 */
export function getAllList(data) {
  return request({
    url: "/CutLicense/GetAllList",
    method: "POST",
    data
  })
}
/**
 * 添加采伐证审批
 * @param {*} data
 * {
 *  "userType": 0,
 *  "uniqueID": "string",
 *  "phone": "string",
 *  "address": "string",
 *  "userName": "string",
 *  "geo": [
 *    [
 *      [
 *        0
 *      ]
 *    ]
 *  ],
 *  "isFirst": true,
 *  "area": 0,
 *  "capacity": 0
 * }
 * @returns
 */
export function addCutLicenseApproval(data) {
  return request({
    url: "/CutLicense/Add",
    method: "POST",
    data
  })
}
/**
 * 设置采伐证优先审批
 * @param {*} data
 * {
 *  "id": 0,
 *  "isFirst": true
 * }
 * @returns
 */
export function setCutLicenseApprovalFirst(data) {
  return request({
    url: "/CutLicense/SetFirst",
    method: "POST",
    data
  })
}
/**
 * 新增采伐证
 * @param {*} data
 * {
 *  "id": 1,
 *  "isPass": true,
 *  "opinion": "string",
 *  "backId": 0
 * }
 * @returns
 */
export function approvalCutLicense(data) {
  return request({
    url: "/CutLicense/SetState",
    method: "POST",
    data
  })
}

/**
 * 一件添加采伐证
 * @param {*} data
 * {
 *  "id": 1,
 *  "isPass": true,
 *  "opinion": "string",
 *  "backId": 0
 * }
 * @returns
 */
export function addCutLicenseApproval2(data) {
  return request({
    url: "/CutLicense/AddOneKey",
    method: "POST",
    data
  })
}
/**
 * 通过ID删除采伐证审批
 * @param {*} data
 * {
 *  "id": 02
 * }
 * @returns
 */
export function deleteCutLicenseById(data) {
  return request({
    url: "/CutLicense/Delete",
    method: "POST",
    data
  })
}

/**
 * 通过id获取审批台账详情
 * @param {*} data
 * {
 *  "id": 02
 * }
 * @returns
 */
export function getCutLicenseDetailById(id) {
  return request({
    url: `/CutLicense/GetDetails?id=${id}`,
    method: "GET",
  })
}

/**
 * 获取审核图形（工作人员）
 * @param {*} data
 * {
 *  "id": 02
 * }
 * @returns
 */
export function GetReviceAllGeo(id) {
  return request({
    url: `/CutLicense/GetReviceAllGeo?selectId=${id}`,
    method: "GET",
  })
}

// 获取实地照片信息（工作人员）
export function GetSDImages(id) {
  return request({
    url: `/CutLicense/GetSDImages?id=${id}`,
    method: "GET",
  })
}

// 获取所有审核图形（工作人员）
export function GetAllReviceGeo(dateTime) {
  return request({
    url: `/CutLicense/GetAllReviceGeo?dateTime=${dateTime}`,
    method: "GET",
  })
}

/**
 * 添加审批预设（工作人员）
 * @param {*} data 
 * @returns 
 */
export function AddAuditPreset(data) {
  return request({
    url: "/CutLicense/AddAuditPreset",
    method: "POST",
    data
  })
}

/**
 * 修改审批预设（工作人员）
 * @param {*} data 
 * @returns 
 */
export function UpdateAuditPreset(data) {
  return request({
    url: "/CutLicense/UpdateAuditPreset",
    method: "POST",
    data
  })
}

/**
 * 删除审批预设（工作人员）
 * @param {*} id 
 * @returns 
 */
export function DeleteAuditPreset(id) {
  return request({
    url: `/CutLicense/DeleteAuditPreset?id=${id}`,
    method: "GET",
  })
}

/**
 * 获取审批预设下拉框（工作人员）
 * @returns 
 */
export function GetAuditPresetBox() {
  return request({
    url: '/CutLicense/GetAuditPresetBox',
    method: "GET",
  })
}

/**
 * 获取审批预设列表（工作人员）
 * @param {*} data 
 * @returns 
 */
export function GetAuditPresetLis(data) {
  return request({
    url: "/CutLicense/GetAuditPresetLis",
    method: "POST",
    data
  })
}



/**
 * 批量导出操作记录清单Excel
 * @param {*} id 
 * @returns 
 */
export function DownReviceHistoryExcel(id) {
  return request({
    url: `/CutLicense/DownReviceHistoryExcel?id=${id}`,
    method: "GET",
    responseType:'blob'
  })
}

/**
 * 获取导出图层流程
 * @param {*} data 
 * @returns 
 */
export function GetLicenseFlowchart(data) {
  return request({
    url: "/CutLicense/GetLicenseFlowchart",
    method: "GET",
    data
  })
}


/**
 * 下载shape文件(工作人员)
 * @param {*} data 
 * @returns 
 */
export function DownShapeFile(data) {
  return request({
    url: "/CutLicense/DownShapeFile",
    method: "POST",
    data,
    responseType:'blob'
  })
}

/**
 * 批量导出审批记录(工作人员)
 * @param {*} data 
 * @returns 
 */
export function DownSPJLZip(data) {
  return request({
    url: `/CutLicense/DownSPJLZip`,
    method: "POST",
    data,
    responseType:'blob'
  })
}

/**
 * 导出单个审批记录(工作人员)
 * @param {*} data 
 * @returns 
 */
export function DownSPJLExcel(id) {
  return request({
    url: `/CutLicense/DownSPJLExcel?id=${id}`,
    method: "GET",
    responseType:'blob'
  })
}




